<script>
  import { Link, imgSrc } from '$client';
  export let data;
  export let catalogs = [];
  export let type = 'self';
  const order = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];
  const sort = (prev, next) => order.indexOf(prev.split('/')[1]) - order.indexOf(next.split('/')[1]);
  const getImg = el => el.attributes.cardImg.data.attributes;
  $: sorted = catalogs.sort((a, b) => sort(getImg(a).caption, getImg(b).caption));
</script>

<section class="container about">
  <svelte:element this={type === 'self' ? 'h1' : 'h2'} class={type === 'self' ? 'h1' : 'h2'}
    >{data.header}</svelte:element>
  <div>
    <p>{@html data.description}</p>
    <div id="about-links">
      <nav>
        {#each sorted as catalog}
          <Link
            attributes={{
              class: getImg(catalog).caption.split('/')[0] + ' push-button',
              'data-position': getImg(catalog).caption.split('/')[1],
            }}
            href="/kategoriya-{catalog.attributes.url}">
            <img
              loading="lazy"
              decoding="async"
              height="100"
              width="100"
              src={imgSrc(catalog.attributes.cardImg.data.attributes.url)}
              alt={catalog.attributes.cardImg.data.attributes.alternativeText} />
            <span>{catalog.attributes.ancor}</span>
          </Link>
        {/each}
      </nav>
    </div>
  </div>

  <div>
    {#each data.data as advantage}
      <article>
        <p>{advantage.description}</p>
        <svelte:element this={type === 'self' ? 'h2' : 'h3'}>{@html advantage.header}</svelte:element>
      </article>
    {/each}
  </div>
  <img
    class="map"
    height={data.img.data.attributes.height}
    width={data.img.data.attributes.width}
    loading="lazy"
    src={imgSrc(data.img.data.attributes.url)}
    alt={data.img.data.attributes.alternativeText} />
</section>

<style lang="scss">
  section > h1,
  section > h2 {
    margin-bottom: 30px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
  }

  .map {
    width: 100%;
    height: auto;
    margin-bottom: 50px;
  }

  section > div:first-of-type {
    display: inline-flex;
    gap: 40px;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    p {
      max-width: 510px;
      color: #2c333c;
      font-weight: 500;
      font-size: 18px;
      font-family: Roboto;
      line-height: 140%;

      @media only screen and (max-width: 575.98px) {
        font-size: 16px;
      }
    }

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;

      p {
        max-width: 100%;
      }
    }
  }

  section > div:last-of-type {
    display: inline-flex;
    gap: 30px;
    justify-content: space-between;
    width: 100%;
    padding-block: 50px;

    p {
      color: #0da575;
      font-weight: normal;
      font-size: 118px;
      font-family: Vela Sans;
      font-style: normal;
      white-space: nowrap;

      @media only screen and (max-width: 575.98px) {
        font-size: 60px;
        text-align: center;
      }
    }

    h2,
    h3 {
      color: #2c333c;
      font-weight: bold;
      font-size: 20px;
      font-family: Vela Sans;
      font-style: normal;
    }

    @media only screen and (max-width: 1100.98px) {
      flex-wrap: wrap;
      justify-content: center;

      article {
        :global(br) {
          display: none;
        }
      }
    }
  }

  #about-links {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  nav {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: flex-start;

    img {
      position: absolute;
      width: 128px;
      height: 128px;
      object-fit: contain;
    }

    :global(a) {
      position: relative;
      display: flex;
      width: 220px;
      height: 140px;
      padding: 20px;
      overflow: hidden;
      font-weight: bold;
      font-size: 22px;
      font-family: Vela Sans;
      border-radius: 15px;
    }

    :global(a:nth-child(even)) {
      margin-top: -20px;
      text-align: end;
    }

    :global(a[data-position='bottom-right'] > img) {
      position: absolute;
      right: -10px;
      bottom: 0;
    }

    :global(a[data-position='bottom-left'] > img) {
      position: absolute;
      bottom: 0;
      left: -20px;
    }

    :global(a[data-position='top-right']) {
      align-items: flex-end;

      :global(img) {
        position: absolute;
        top: 0;
        right: -20px;
      }
    }

    :global(a[data-position='top-left']) {
      align-items: flex-end;
      justify-content: flex-end;

      :global(img) {
        position: absolute;
        top: 0;
        left: -10px;
      }
    }

    :global(a[class~='white-bg']) {
      color: rgb(44 51 60 / 80%);
      box-shadow:
        -1px 0 4px rgb(0 0 0 / 6%),
        9px 9px 10px rgb(0 15 92 / 5%);
    }

    :global(a[class~='green-bg']) {
      color: #2c333c;
      background: #22eaac;
    }

    :global(a[class~='black-bg']) {
      color: rgb(255 255 255 / 80%);
      background: rgb(44 51 60);
    }

    @media only screen and (max-width: 575.98px) {
      grid-template-columns: 1fr;

      :global(a:nth-child(even)) {
        margin-top: 0;
        margin-left: -40px;
        text-align: end;
      }

      :global(a:nth-child(odd)) {
        margin-right: -40px;
      }
    }
  }
</style>
